import React from "react";
import {inject, observer} from "mobx-react";
import {Router as Router} from "react-router-dom";
import {Async as AsyncSelect} from 'react-select';
    
//import {DateUtils, LocaleUtils} from 'react-day-picker';
//import {format as dateFnsFormat, parse as dateFnsParse} from 'date-fns';
// import dateFnsFormat from 'date-fns/format';
// import dateFnsParse from 'date-fns/parse';
import debounce from '@utils/debounce';


// function parseDate(str, format, locale) {
//     const parsed = dateFnsParse(str, format, new Date(), {locale});
//     if (DateUtils.isDate(parsed)) {
//         return parsed;
//     }
//     return undefined;
// }
//
// function formatDate(date, format, locale) {
//     return dateFnsFormat(date, format, {locale});
// }


function getFirstDayOfWeek(locale) {

    return 1; // monday;
}

@inject("store")
@observer
export default class CustomerSelector extends React.Component {

    DATE_FORMAT = 'yyyy-MM-dd';

    constructor(props) {
        super(props);
        this.searchCustomers = this.searchCustomers.bind(this);

        this.state = {
            allowDateChange: false,
            editOrder: false,
            editOrderReference: ""
        };
    }

    formatCustomer(customer) {
        return (<div className="text-left"><strong>{customer.Name}</strong>&nbsp;({customer.Number}), {customer.City}</div>);
    }

    async searchCustomers(input) {

        const accountStore = this.props.store.account;
        if (input === "") {
            console.debug("searchCustomers-start", input === "", accountStore.Customers.toJSON());
            return accountStore.Customers;
        }

        const result = await this.props.store.account.searchCustomer(input);
        return result.Customers;
    }

    render() {
        const navigation = this.props.store.navigation;
        const account = this.props.store.account;
        // const siteTree = navigation.siteTree;
        //
        // const currentSiteId = navigation.mainTree.Id;
        // const matchingSite = siteTree.Children.find(x => x.Id === currentSiteId);

        const currentCustomerId = navigation.getCustomerId();

        const currentCustomer = account.Customers.find(function (item) {
            return currentCustomerId && item.Id === currentCustomerId;
        });
        const currentCustomerRole = currentCustomer ? currentCustomer.Role : "";


        const customersSearchable = typeof account.Roles.find(x => x === "icom-admin") !== 'undefined';


        if (!account.Ready) {
            return (<div>Loading account...</div>);
        }

        return (
            <div className="site-selector">
                <div className="site-selector-background" style={{backgroundImage: "url('')"}}></div>
                <div style={{display: "flex", width: "100%", height: "100%", justifyContent: "center"}}>
                    <div style={{width: 600, margin: "auto 15px"}}>
                        <div className="row">
                            <div className="col-12">
                                <div className="card mb-3" style={{minHeight: 500}}>
                                    <React.Fragment>
                                        <div className="card-body">
                                            <h4 className="card-title text-center my-5">Välj kund</h4>
                                            <AsyncSelect
                                                className="select-customer"
                                                cacheOptions
                                                defaultOptions
                                                isSearchable={customersSearchable}
                                                getOptionLabel={(customer) => {
                                                    return this.formatCustomer(customer)
                                                }}
                                                getOptionValue={(customer) => {
                                                    return customer;
                                                }}
                                                value={
                                                    navigation.CurrentCustomerId &&
                                                    account.Customers.find(customer => customer.Id === navigation.CustomerId)
                                                }
                                                loadOptions={debounce((input, callback) => {
                                                    this.searchCustomers(input).then(result =>
                                                        callback(result)).catch(err => callback(err));
                                                }, 400)}

                                                noOptionsMessage={() => "Börja skriva för att söka efter en kund"}
                                                placeholder="Välj kund..."
                                                isClearable={true}
                                                onChange={(customer) => {
                                                    
                                                    navigation.setCustomer(customer);
                                                    if(account.ShowSettingsDialog) {
                                                        account.setShowSettingsDialog(false);
                                                    }
                                                    
                                                    //this.setState({ editOrder: false, editOrderReference: "" });
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

